<template>
  <div class="relative">
    <div class="relative">
      <div
        class="border-gray-150 border border-solid absolute w-12 top-0 right-0 h-full rounded-r p-2 bg-gray-50 flex items-center justify-center ease-linear transition-all duration-150"
      >
        <img v-if="selectedIcon" class="w-5" :src="selectedIcon" :alt="icon" />
        <IconEarth v-else class="fill-lightGray" />
      </div>
      <input
        readonly
        @focus="handleFocus"
        @blur="handleBlur"
        v-model="iconLocal"
        class="border-0 pr-[70px] px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
      />
    </div>
    <div
      v-if="activated"
      class="z-10 p-2 rounded bg-white absolute mt-2 shadow"
    >
      <div class="p-2 shadow bg-gray-100"><p>Icons</p></div>
      <div class="overflow-scroll max-h-[300px] flex flex-wrap">
        <div
          @mousedown="(e) => handleSelectIcon(e, icon, name)"
          class="cursor-pointer shadow p-3 m-2 rounded ease-linear transition-all duration-200 hover:bg-gray-50"
          v-for="(icon, name) in icons"
          :key="name"
        >
          <div class="flex items-center justify-center flex-col">
            <img class="h-7 mb-2" :src="icon" alt="icon" />
            <p class="text-xs max-w-[70px] truncate">{{ name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconEarth from "@/assets/icons/IconEarth";

export default {
  components: {
    IconEarth
  },
  props: {
    icons: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activated: false,
      selectedIcon: null
    };
  },
  mounted() {
    if (this.icon) {
      this.selectedIcon = this.icons[this.icon];
    }
  },
  watch: {
    icon() {
      this.selectedIcon = this.icons[this.icon];
    }
  },
  computed: {
    iconLocal: {
      get: function () {
        return this.icon;
      },
      set: function (val) {
        this.$emit("update:icon", val);
      }
    }
  },
  emits: ["update:icon"],
  methods: {
    handleFocus() {
      this.activated = true;
    },
    handleBlur() {
      this.activated = false;
    },
    handleSelectIcon(e, icon, name) {
      e.preventDefault();
      this.iconLocal = name;
      this.selectedIcon = icon;
    }
  }
};
</script>
